import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer from "@insite/mobius/GridContainer";
// import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import RequestQuoteModal from "@MasterBluePrint/Components/RequestQuoteModal";
import setRequestQuoteModalIsOpen from "@MasterBluePrint/Store/Components/RequestQuoteModal/Handlers/SetRequestQuoteModalIsOpen";
import { MasterState } from "@MasterBluePrint/Store/MasterState";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    requestQuoteTitle = "requestQuoteTitle",
    requestQuoteLinkText = "requestQuoteLinkText",
    requestQuoteFormId = "requestQuoteFormId",
}

interface OwnProps extends WidgetProps {
    extendedStyles?: ButtonPresentationProps;
    fields: {
        [fields.requestQuoteTitle]: string;
        [fields.requestQuoteLinkText]: string;
        [fields.requestQuoteFormId]: string;
    };
}

type Props = OwnProps & HasProduct & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>; // &
// HasProductContext;

const mapStateToProps = (state: MasterState) => ({
    productSettings: getSettingsCollection(state).productSettings,
});

const mapDispatchToProps = {
    setRequestQuoteModalIsOpen,
};

export interface ProductDetailsRequestQuoteModalStyle {
    requestQuoteMainContainer?: InjectableCss;
    requestQuoteLink?: InjectableCss;
}

export const productDetailsRequestQuoteModalStyle: ProductDetailsRequestQuoteModalStyle = {
    requestQuoteMainContainer: {
        css: css`
            background-color: #fff;
            font-weight: 600;
            font-size: 0.85rem;
            margin-bottom: 0.2em;
            margin-top: 0.9375rem;
            text-align: center;
            > div {
                background-color: #fff;
                box-shadow: 0 0 0px 10px #fff;
                padding: 0.625rem 0;
                justify-content: center;
            }
        `,
    },
    requestQuoteLink: {
        css: css`
            color: #333f48;
            font-family: Lato;
            font-size: 0.875rem;
            letter-spacing: 0;
            line-height: 1.5rem;
            text-decoration: underline;

            span {
                color: #333f48 !important;
            }
        `,
    },
};

export const productDetailsRequestQuoteButtonStyles: ButtonPresentationProps = {};

const ProductDetailsRequestQuoteButton: React.FC<Props> = ({
    fields,
    product,
    productInfo,
    extendedStyles,
    setRequestQuoteModalIsOpen,
}) => {
    const [styles] = React.useState(() => mergeToNew(productDetailsRequestQuoteModalStyle, extendedStyles));

    if (product.unitListPrice > 0) {
        return null;
    }

    if (product) {
        const requestQuoteClickHandler = () => {
            setRequestQuoteModalIsOpen({
                modalIsOpen: true,
                productNumber: product.productNumber,
            });
        };

        return (
            <GridContainer {...styles.requestQuoteMainContainer}>
                <RequestQuoteModal formId={fields.requestQuoteFormId}/>
                <Button
                    style={{
                        color: "#002554",
                        fontFamily: "'Roboto', sans-serif",
                        fontSize: "1rem",
                        padding: "0",
                        fontWeight: "bold",
                        textTransform: "uppercase",
                        marginBottom: "1.2rem",
                        marginTop: ".5rem",
                        width: "100%",
                        backgroundColor: "white",
                    }}
                    {...styles}
                    onClick={requestQuoteClickHandler}
                    data-test-selector="productDetailsRequestQuoteButton"
                >
                    {fields.requestQuoteLinkText}
                </Button>
            </GridContainer>
        );
    }
    return <></>;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withProduct(ProductDetailsRequestQuoteButton)),
    definition: {
        displayName: "Request a Quote Button",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
        fieldDefinitions: [
            {
                name: fields.requestQuoteTitle,
                editorTemplate: "TextField",
                defaultValue: "Request a Quote",
                fieldType: "Translatable",
            },
            {
                name: fields.requestQuoteLinkText,
                editorTemplate: "TextField",
                defaultValue: "Request a Quote",
                fieldType: "Translatable",
            },            
            {
                name: fields.requestQuoteFormId,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
        ],
    },
};
export default widgetModule;
